<div class="dropdown-item" *ngIf="!isMenuItemTypeLink()">
  <span>{{ menuItemText }}</span>
  <span
    class="right"
    [ngClass]="{
      switch: isMenuItemTypeSwitch(),
      'radio-select': isMenuItemTypeRadioSelection()
    }"
  >
    <ds-switch
      *ngIf="isSwitchVisible()"
      [checked]="selectedMenuItemOption === menuItemOptions[0].value"
      (change)="emitSwitchChanges($event)"
    >
      <span ds-switch-on>{{ menuItemOptions[0].label }}</span>
      <span ds-switch-off>{{ menuItemOptions[1].label }}</span>
    </ds-switch>

    <ds-radio-group [ariaLabel]="menuItemLabel" *ngIf="isRadioVisible()">
      <div class="display-flex wrap">
        <ds-selection
          *ngFor="let option of menuItemOptions; let last = last"
          [ngClass]="{ 'margin-right': !last }"
          [value]="option.value"
          [checked]="option.value === selectedMenuItemOption"
          (change)="emitRadioChanges($event)"
        >
          {{ option.label }}
        </ds-selection>
      </div>
    </ds-radio-group>
  </span>
</div>
<div class="link-item" *ngIf="isMenuItemTypeLink() && isMenuItemVisible">
  <dsa-cta [data]="ctaData" (ctaClick)="emitLinkClicked()"></dsa-cta>
</div>
